import { deriveChargeCadence } from "./derive-cadence";
import { scalesWithSessions } from "./types";

/**
 * Compute a V2 ticket's display/session price considering chargeType
 * (free / PWYW use their own base price) and chargeCadence (flat / per_course
 * don't scale with session count; per_ticket_per_session / per_session do).
 * Non-standard chargeTypes (deposit, pay_what_you_want, free) always use
 * per_ticket_per_session — cadence only applies to standard tickets, matching
 * CalculateV2Price.service.ts. Clamp to 1 session so a missing/unloaded
 * session count never flattens a per-session price to £0 — callers are
 * expected to drop the option when there are truly no sessions, not show
 * "From £0".
 */
export function deriveV2SessionPrice(tt: any, numberOfSessions: number): number {
  let basePrice = tt.price ?? 0;
  if (tt.chargeType === "free") {
    basePrice = 0;
  } else if (tt.chargeType === "pay_what_you_want" && tt.chargeConfig) {
    basePrice = tt.chargeConfig.suggestedPrice ?? tt.price ?? 0;
  }
  const cadence =
    (tt.chargeType ?? "standard") === "standard"
      ? deriveChargeCadence(tt)
      : "per_ticket_per_session";
  const multiplier = scalesWithSessions(cadence) ? Math.max(numberOfSessions, 1) : 1;
  return Math.ceil(basePrice * multiplier);
}
